import {useSelector,useDispatch} from 'react-redux'
import {
	copyWeekdayAvailabilityRanges,
	selectWeekdayAvailabilityRangeById,
	createWeekdayAvailabilityRange,
	removeWeekdayAvailabilityRange,
	editWeekdayAvailabilityRange,
	selectWeekdayAvailabilityById,
	selectAllWeekdayAvailabilities,
	selectWeekdayAvailabilityIds,
	getWeekdayAvailabilities,
	editWeekdayAvailability
} from '../../state/schedulerSlice'

export const useWeekdayAvailabilities = ()=>{
	const dispatch = useDispatch()
	const {status,show} = useSelector(state=>state.scheduler.weekdayAvailabilities)
	const ids = useSelector(selectWeekdayAvailabilityIds)
	const availabilities = useSelector(selectAllWeekdayAvailabilities)

	if (status === 'init') {
		dispatch(getWeekdayAvailabilities())
	}

	return {status,ids,availabilities,show}
}

export const useWeekdayAvailabilityMutations = ()=>{
	const dispatch = useDispatch()
	const edit = payload => dispatch(editWeekdayAvailability(payload))

	return {edit}
}

export const useWeekdayAvailability = (id)=>(
	useSelector(state=>selectWeekdayAvailabilityById(state,id))
)


export const useWeekdayAvailabilityRange = (id)=>(
	useSelector(state=>selectWeekdayAvailabilityRangeById(state,id))
)


export const useWeekdayAvailabilityRangeMutations = ()=>{
	const dispatch = useDispatch()
	const edit = payload => dispatch(editWeekdayAvailabilityRange(payload))
	const remove = id => dispatch(removeWeekdayAvailabilityRange(id))
	const create = payload => dispatch(createWeekdayAvailabilityRange(payload))
	const copy = payload => dispatch(copyWeekdayAvailabilityRanges(payload))

	return {edit,remove,create,copy}
}